export const localizeErrorMessage = (message) => ({
  'Invalid account or password': '帳號或密碼錯誤',
  'User disabled': '帳號已停用',
  'Missing fields': '請填寫所有必填欄位',
  'Account or email already exists': '帳號或 Email 已存在',
  'Current password is incorrect': '目前密碼錯誤',
  'Password confirmation does not match': '新密碼與確認密碼不一致',
  'Password must be at least 8 characters': '密碼至少需要 8 碼',
  'New password cannot be the default password': '新密碼不可使用預設密碼',
}[message] || message);
